import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, Type } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'tar-icon-button',
  imports: [ButtonModule, CommonModule, ProgressSpinnerModule],
  standalone: true,
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.display]': 'hostDisplay()',
  },
})
export class IconButtonComponent {
  public type = input<'primary' | 'secondary' | 'action'>('primary');
  public severity = input<'primary' | 'contrast'>('primary');
  public iconPos = input<'left' | 'right' | 'top' | 'bottom'>('right');
  public icon = input<string>('ph ph-caret-right ph-bold');
  public iconComponent = input<Type<any> | null>(null);
  public disabled = input<boolean>(false);
  public borderless = input<boolean>(false);
  public padingless = input<boolean>(false);
  public label = input<string>('');
  public loadLabel = input<string>('');
  public ariaLabel = input<string>();
  public size = input<'small' | 'large' | undefined | null>(undefined);
  public fullWidth = input<boolean>(false);
  public id = input<string>('');
  public loading = input<boolean>(false);
  public style = input<Record<string, any> | null>(null);
  public suffixIcon = input<string>();
  public styleClass = input<string>();
  public useDisplayContents = input(true);

  protected hostDisplay = computed(() => {
    return this.useDisplayContents() ? 'contents' : null;
  });
}
